import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import StepMenuItem from '@r1-frontend/ui-react/components/StepMenu/StepMenuItem';
import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const StyledStepMenuContainer = styled.nav`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;

  ${StepMenuItem} {
    background-color: ${COLORS.ButtonSecondary};
    
    @media (max-width: ${wideBreakpoints.mobile}) {
      padding: 4px 0;
      gap: 4px;
      
      &:not(.current) {
        flex: initial;
        & > p {
          display: none;
        }
      }
    }
  }

  ${StepMenuItem}.last-activated ~ ${StepMenuItem}{
    background-color: ${COLORS.BgSurface};
    cursor: initial;
    transform: none;
    pointer-events: none;
    
    & > p {
      color: ${COLORS.TextDisabled};
    }

    & > ${Svg}, & > img {
      filter: grayscale(1);
      opacity: .3;
    }
  }
`;
